var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBroadcastFullscreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17027_5051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 20C57.8 20 56 18.2 56 16V13.7L46.1 23.6C44.5 25.2 42 25.2 40.4 23.6C38.8 22 38.8 19.5 40.4 17.9L50.3 8H48C45.8 8 44 6.2 44 4C44 1.8 45.8 0 48 0H60C62.2 0 64 1.8 64 4V16C64 18.2 62.2 20 60 20Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00005 50.1L17.9001 40.2C19.5001 38.6 22 38.6 23.6 40.2C25.2 41.8 25.2 44.3 23.6 45.9L13.7 55.8H16.0001C18.2001 55.8 20.0001 57.6 20.0001 59.8C20.0001 62 18.2001 63.8 16.0001 63.8H4.00005C1.80005 63.8 4.95911e-05 62 4.95911e-05 59.8V47.8C4.95911e-05 45.6 1.80005 43.8 4.00005 43.8C6.20005 43.8 8.00005 45.6 8.00005 47.8V50.1Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17027_5051"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroadcastFullscreen);
export default __webpack_public_path__ + "static/media/broadcast-fullscreen.27ebff63ba18fac0a24f7a706d8975f4.svg";
export { ForwardRef as ReactComponent };